<template>
  <div v-if="user" class="user_info-label">
    <div class="user_info-label__icon">
      <avatar :user="user" :border="false" />
    </div>

    <div>
      <div class="user_info-label__desc">
        {{ roleName }}
      </div>
      <div class="user_info-label__name">
        {{ user.name }}
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar.vue'
  export default {
    name: 'UserInfoLabel',
    components: { Avatar },
    props: {
      user: Object,
    },
    computed: {
      roleName () {
        return this.user?.role?.name
      },
    },
  }
</script>

<style lang="less" scoped>
.user_info-label {
    display: flex;
    align-items: center;
  justify-content: flex-end;
    flex-basis: 30%;

  &__icon {
    width: 1em;
    height: 1em;
    border-radius: 50%;
    background: #fff;
    margin-right: 0.3em;
    font-size: 2.7em;

    ::v-deep {
      .avatar {
        width: 1em;
        height: 1em;
      }
    }
  }

  &__desc {
    font-size: 0.8em;
    line-height: 1;
    color: #C4CDD9;
    margin-bottom: 0.2em;
  }

  &__name {
    line-height: 1.1;
    min-width: 7em;
  }
}
</style>
